// src/features/clinical/components/patient/PatientList.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaPhone, FaCalendar, FaHeart, FaExclamationTriangle } from 'react-icons/fa';

const PatientList = ({ patients, onSelectPatient }) => {
  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Patient
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Contact
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Age/Gender
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Blood Group
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Allergies
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {patients.map((patient) => (
            <tr key={patient.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaUser className="h-5 w-5 text-blue-600" />
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900">{patient.name}</div>
                    <div className="text-sm text-gray-500">ID: {patient.patientId}</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900 flex items-center">
                  <FaPhone className="mr-2 h-3 w-3 text-gray-400" />
                  {patient.contact}
                </div>
                <div className="text-sm text-gray-500">{patient.email}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">{calculateAge(patient.dateOfBirth)} years</div>
                <div className="text-sm text-gray-500">{patient.gender}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                  {patient.bloodGroup || 'Not Specified'}
                </span>
              </td>
              <td className="px-6 py-4">
                {patient.allergies && patient.allergies.length > 0 ? (
                  <div className="flex items-center">
                    <FaExclamationTriangle className="h-4 w-4 text-yellow-500 mr-1" />
                    <span className="text-sm text-gray-900">{patient.allergies.join(', ')}</span>
                  </div>
                ) : (
                  <span className="text-sm text-gray-500">No known allergies</span>
                )}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <button
                  onClick={() => onSelectPatient(patient)}
                  className="text-blue-600 hover:text-blue-900 mr-4"
                >
                  Select
                </button>
                <Link
                  to={`/clinical/patients/${patient.id}`}
                  className="text-green-600 hover:text-green-900"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {patients.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500">No patients found</p>
        </div>
      )}
    </div>
  );
};

export default PatientList;